/* src/app/shared/components/layout/expires-privilege-dialog/expires-privilege-dialog.component.scss */
/*# sourceMappingURL=expires-privilege-dialog.component.css.map */
